module.exports = __webpack_public_path__ + "img/part5-7.850ef98c.png";